import React, { Component } from 'react';
import creditPage from '../decorators/creditPage';
import Credit from '../components/Credit/Credit';
import CancelCredit from '../components/Credit/CancelCredit';
import DeleteCredit from '../components/Credit/DeleteCredit';

export class ViewCredit extends Component {
  state = {
    isOpenCancel: false,
    isOpenDelete: false,
  };

  openDelete = () => {
    this.setState({
      isOpenDelete: true,
    });
  };

  openCancel = () => {
    this.setState({
      isOpenCancel: true,
    });
  };

  closeDelete = () => {
    this.setState({
      isOpenDelete: false,
    });
  };

  closeCancel = () => {
    this.setState({
      isOpenCancel: false,
    });
  };

  handleDelete = () => {
    const { deleteCredit, credit } = this.props;
    deleteCredit(credit.id);
    this.closeDelete();
  };

  handleCancel = () => {
    const { cancelCredit, credit } = this.props;
    cancelCredit(credit.id);
    this.closeCancel();
  };

  render() {
    const { credit, notFound, error, success, isAdmin, carrier, sub, subId } =
      this.props;
    const { isOpenCancel, isOpenDelete } = this.state;

    if (notFound) {
      return <div>Not Found</div>;
    }

    if (!credit) {
      return <div>Loading...</div>;
    }

    return (
      <div>
        <Credit
          credit={credit}
          isAdmin={isAdmin}
          onCancel={this.openCancel}
          onDelete={this.openDelete}
          error={error}
          success={success}
          carrier={carrier}
          sub={sub}
          subId={subId}
        />
        {isAdmin && (
          <CancelCredit
            isOpen={isOpenCancel}
            onConfirm={this.handleCancel}
            onDecline={this.closeCancel}
          />
        )}
        {isAdmin && (
          <DeleteCredit
            isOpen={isOpenDelete}
            onConfirm={this.handleDelete}
            onDecline={this.closeDelete}
          />
        )}
      </div>
    );
  }
}

export const WrappedViewCredit = creditPage(ViewCredit);

export default WrappedViewCredit;
